/// <amd-module name="SuiteCommerce.GiftCertificate.Customer.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.Customer.Model", ["require", "exports", "Backbone", "SuiteCommerce.GiftCertificates.Collection"], function (require, exports, Backbone_1, GiftCertificate_Collection_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CustomerModel = void 0;
    var CustomerModel = /** @class */ (function (_super) {
        __extends(CustomerModel, _super);
        function CustomerModel(attributes) {
            var _this = _super.call(this, attributes) || this;
            _this.giftCertificatesCollection = new GiftCertificate_Collection_1.GiftCertificateCollection();
            if (attributes.customerId) {
                _this.customerId = attributes.customerId;
            }
            return _this;
        }
        Object.defineProperty(CustomerModel.prototype, "customerId", {
            get: function () {
                return this.get('customerId');
            },
            set: function (customerId) {
                this.set('customerId', customerId);
            },
            enumerable: false,
            configurable: true
        });
        CustomerModel.prototype.fetchGiftCertificateList = function () {
            return this.giftCertificatesCollection.fetch();
        };
        return CustomerModel;
    }(Backbone_1.Model));
    exports.CustomerModel = CustomerModel;
});
